export const CondicaoData = {
  condicaoFinalizadora: '',
  numCondicao: '',
  condicao: '',
};
